<span aria-hidden="true" class="inline-flex items-center justify-center" role="status">
	<uc-loading-spinner-svg></uc-loading-spinner-svg>
	<span>{{ buttonText }}</span>
</span>
